// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2S-UQ","right":"styles_right__3bD-S"};